import React from 'react'
import { motion } from 'framer-motion'
import { Sparkles, Loader2 } from 'lucide-react'

export function AnalyticsButton({ onClick, isLoading }) {
    return (
        <div className="tw-flex-shrink-0 tw-mb-2.5">
            <motion.button
                whileHover={{ scale: 1.005 }}
                whileTap={{ scale: 0.995 }}
                onClick={onClick}
                disabled={isLoading}
                className="
                    tw-w-full tw-flex tw-items-center tw-gap-2.5 tw-px-2.5 tw-py-2
                    tw-rounded-lg tw-border tw-border-dashed
                    tw-border-neutral-300 dark:tw-border-neutral-600/50
                    tw-bg-neutral-50 dark:tw-bg-neutral-800/40
                    hover:tw-bg-neutral-100 dark:hover:tw-bg-neutral-800/70
                    hover:tw-border-neutral-400 dark:hover:tw-border-neutral-500/60
                    tw-transition-all tw-duration-200
                    disabled:tw-opacity-60 disabled:tw-cursor-not-allowed
                    tw-group tw-text-left
                "
            >
                <div className="tw-flex-shrink-0 tw-w-6 tw-h-6 tw-rounded-md tw-bg-neutral-200/60 dark:tw-bg-neutral-700/40 tw-flex tw-items-center tw-justify-center group-hover:tw-bg-neutral-200 dark:group-hover:tw-bg-neutral-700/60 tw-transition-colors">
                    {isLoading ? (
                        <Loader2 className="tw-w-3.5 tw-h-3.5 tw-text-neutral-500 dark:tw-text-neutral-400 tw-animate-spin" />
                    ) : (
                        <Sparkles className="tw-w-3.5 tw-h-3.5 tw-text-neutral-500 dark:tw-text-neutral-400" />
                    )}
                </div>
                <div className="tw-min-w-0">
                    <p className="tw-text-xs tw-font-medium tw-text-neutral-700 dark:tw-text-neutral-300 tw-leading-none">
                        {isLoading
                            ? 'Analyzing network...'
                            : 'Auto-Generate from Analytics'}
                    </p>
                    <p className="tw-text-[10px] tw-text-neutral-400 dark:tw-text-neutral-500 tw-mt-0.5 tw-leading-none">
                        Pull Analytics insights for RAG enhancement
                    </p>
                </div>
            </motion.button>
        </div>
    )
}
